import useApi from "./useApiRequest";
import { useMutation } from "react-query";


export const CancelarSalida = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.put(`/administracion-inventario/salida/cancelar/documento/${params}`, {}, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    cancelarSalidaMutation: mutation.mutate,
  };
}